import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import api from '@/api/api'

import { dictionary } from '@/shared/services/dictionary';
import checkService from '@/shared/services/check';
import UploadFile from '@/shared/services/oss.service';
import moment from 'moment';

import { Dialog } from 'vant';
import { isNotNull, isNull } from '@/shared/utils/utils';
@Component({
    components: {},
})
export default class AddResumeBaseInfo extends Vue {
    @Prop() data: any; // 基本信息
    @Prop() inResume: any; // 是否在录用简历中
    @Prop() areaList: any; // 地区信息
    fileLimit: any = { fileType: '*', fileLength: 1, fileSize: 5 }; // 头像限制
    politicalStatusList: any = []; // 政治面貌数据源
    areaProps: any = {}; // 省市组件属性
    nativePlaceHolder: string = '请选择';
    housePlaceHolder: string = '请选择';
    livePlaceHolder: string = '请选择';
    baseForm: any = { // 表单信息
        userName: '',
        avatarUrl: '',
        sex: '',
        birthdayDate: '',
        age: '',
        politicsType: '',
        nativePlaceInfoCode: '',
        houseHoldPlaceInfoCode: '',
        liveCityInfoCode: '',
        liveAddress: '',
        height: '',
        weight: '',
        healthType: '',
        phoneNumber: '',
        mailNumber: '',
        qqNumber: '',
    };
    baseRules: any = { // 表单验证
        userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        // avatarUrl: [
        //     { required: true, message: '请上传头像', trigger: 'blur' }
        // ],
        sex: [
            { required: true, message: '请选择性别', trigger: ['blur', 'change'] }
        ],
        birthdayDate: [
            { required: true, message: '请选择出生年月', trigger: 'blur' }
        ],
        age: [
            { required: true, message: '请输入年龄', trigger: ['blur', 'change'] }
        ],
        politicsType: [
            { required: true, message: '请选择政治面貌', trigger: ['blur', 'change'] }
        ],
        nativePlaceInfoCode: [
            { type: 'array', validator: this.checkAddress, message: '请选择籍贯', trigger: ['blur', 'change'] }
        ],
        houseHoldPlaceInfoCode: [
            { type: 'array', validator: this.checkAddress, message: '请选择户籍地', trigger: ['blur', 'change'] }
        ],
        liveCityInfoCode: [
            { type: 'array', validator: this.checkAddress, message: '请选择家庭常住地', trigger: ['blur', 'change'] }
        ],
        height: [
            { required: true, message: '请输入身高', trigger: 'blur' }
        ],
        weight: [
            { required: true, message: '请输入体重', trigger: 'blur' }
        ],
        healthType: [
            { required: true, message: '请输入有无病史', trigger: 'blur' }
        ],
        phoneNumber: [
            { validator: this.checkPhoneNumber, trigger: 'blur' }
        ],
        mailNumber: [
            { validator: this.checkEmail, trigger: 'blur' }
        ],
    };

    created() {
        // 政治面貌获取
        this.getPoliticalStatusList();
        // 初始化省市信息
        this.initAreaInfo();
        // 赋值
        if (this.data) {
            this.baseForm = this.data;
            if (this.data.sexType && this.data.sexType === 1) {
                this.baseForm.sex = '男';
            } else if (this.data.sexType && this.data.sexType === 2) {
                this.baseForm.sex = '女';
            }
        }
        this.setCascader(this.data);
    }

    // 地区赋值
    setCascader(item: any) {
        if (isNotNull(item.nativePlaceProCode) && isNotNull(item.nativePlaceCityCode)) {
            this.baseForm.nativePlaceInfoCode = [item.nativePlaceProCode, item.nativePlaceCityCode];
            this.nativePlaceHolder = ((item.nativePlaceProName || item.nativePlaceProName) ?
                `${item.nativePlaceProName || ''} / ${item.nativePlaceCityName || ''}` : this.nativePlaceHolder);
        }

        if (isNotNull(item.houseHoldPlaceProCode) && isNotNull(item.houseHoldPlaceCode)) {
            this.baseForm.houseHoldPlaceInfoCode = [item.houseHoldPlaceProCode, item.houseHoldPlaceCode];
            this.housePlaceHolder = ((item.houseHoldPlaceProName || item.houseHoldPlaceName) ?
                `${item.houseHoldPlaceProName || ''} / ${item.houseHoldPlaceName || ''}` : this.housePlaceHolder);
        }

        if (isNotNull(item.liveProCode) && isNotNull(item.liveCityCode)) {
            this.baseForm.liveCityInfoCode = [item.liveProCode, item.liveCityCode];
            this.livePlaceHolder = ((item.liveProName || item.liveCityName) ?
                `${item.liveProName || ''} / ${this.data.liveCityName || ''}` : this.livePlaceHolder);
        }
    }

    // 监听简历信息变化
    @Watch('data')
    onDataChanged(val: any, oldVal: any) {
        this.baseForm = val;
        if (val.sexType) {
            this.baseForm.sex = (val.sexType === 1 ? '男' : (val.sexType === 2 ? '女' : undefined));
            this.setCascader(val);
        }
    }

    // 获取政治面貌数据源
    getPoliticalStatusList() {
        api.getDictionaries([dictionary.politicsType]).then((res: any) => {
            this.politicalStatusList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 初始化省市信息
    initAreaInfo() {
        this.areaProps = {
            expandTrigger: 'hover',
            label: 'name',
            value: 'code',
            lazy: true,
            lazyLoad(node: any, resolve: any) {
                const { level } = node;
                if (node.data && node.level < 2) {
                    api.getCityInfoById(node.data.id).then((res: any) => {
                        let nodes = res.districtDetails || null;
                        if (nodes && nodes.length > 0) {
                            nodes = nodes.map((item: any) => {
                                item.leaf = (node.level === 1)
                                return item
                            });
                        }
                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                        resolve(nodes);
                    }).catch((error: any) => {
                        Dialog.alert({
                            title: '提示',
                            message: '数据获取失败：' + error,
                        });
                    });
                } else {
                    resolve(null);
                }
            }
        };
    }

    // 选择省市
    changePlace(event: any, type: any) {
        if (type === 1) {
            const nativePlaceNode = (this as any).$refs.nativePlaceCascader.getCheckedNodes()[0];
            if (nativePlaceNode && nativePlaceNode.path) {
                this.baseForm.nativePlaceProCode = nativePlaceNode.path[0];
                this.baseForm.nativePlaceCityCode = nativePlaceNode.path[1];
                this.baseForm.nativePlaceProName = nativePlaceNode.pathLabels[0];
                this.baseForm.nativePlaceCityName = nativePlaceNode.pathLabels[1];
                this.baseForm.nativePlaceInfoCode = [nativePlaceNode.path[0], nativePlaceNode.path[1]];
            }
        } else if (type === 2) {
            const houseHoldPlaceNode = (this as any).$refs.houseHoldPlaceCascader.getCheckedNodes()[0];
            if (houseHoldPlaceNode && houseHoldPlaceNode.path) {
                this.baseForm.houseHoldPlaceProCode = houseHoldPlaceNode.path[0];
                this.baseForm.houseHoldPlaceCode = houseHoldPlaceNode.path[1];
                this.baseForm.houseHoldPlaceProName = houseHoldPlaceNode.pathLabels[0];
                this.baseForm.houseHoldPlaceName = houseHoldPlaceNode.pathLabels[1];
                this.baseForm.houseHoldPlaceInfoCode = [houseHoldPlaceNode.path[0], houseHoldPlaceNode.path[1]];
            }
        } else if (type === 3) {
            const liveCityNode = (this as any).$refs.liveCityCascader.getCheckedNodes()[0];
            if (liveCityNode && liveCityNode.path) {
                this.baseForm.liveProCode = liveCityNode.path[0];
                this.baseForm.liveCityCode = liveCityNode.path[1];
                this.baseForm.liveProName = liveCityNode.pathLabels[0];
                this.baseForm.liveCityName = liveCityNode.pathLabels[1];
                this.baseForm.liveCityInfoCode = [liveCityNode.path[0], liveCityNode.path[1]];
            }
        }
        this.updateInput();
    }

    // 更新input组件值，避免因组件嵌套太深出现input值未更新的情况
    updateInput() {
        this.$forceUpdate();
    }

    // 校验手机号
    checkPhoneNumber(rule: any, value: any, callback: any) {
        if (!value) {
            return callback(new Error('请输入手机号码'));
        } else if (!checkService.isPhone(value)) {
            return callback(new Error('请输入正确的手机号码'));
        } else {
            callback();
        }
    }

    // 校验邮箱
    checkEmail(rule: any, value: any, callback: any) {
        if (!value) {
            return callback(new Error('请输入电子邮箱'));
        } else if (!checkService.isEmail(value)) {
            return callback(new Error('请输入正确的电子邮箱'));
        } else {
            callback();
        }
    }

    // 区域选择校验
    checkAddress(rule: any, value: any, callback: any) {
        if (!value || isNull(value[0]) || isNull(value[1])) {
            return callback(new Error(rule.message));
        } else {
            callback();
        }
    }

    // 上传头像
    beforeFileUpload(file: any) {
        const fileSize = this.fileLimit.fileSize * 1024;
        if (file.file.type !== 'image/png' && file.file.type !== 'image/jpg' && file.file.type !== 'image/jpeg') {
            this.$message({
                message: '请上传为png,jpg,jpeg类型的照片',
                type: 'warning'
            });
            return false;
        } else if ((file.file.size / 1024) > fileSize) {
            this.$message({
                message: '头像最大为' + this.fileLimit.fileSize + 'M',
                type: 'warning'
            });
            return false;
        }
        UploadFile.addFileAliyun(file.file).then(
            (res: any) => {
                this.baseForm.avatarUrl = res.url;
            }
        )
        return false;
    }

    // 根据出生年月计算年龄
    calcAge(event: any) {
        if (!event) {
            return;
        }
        this.baseForm.birthdayDate = moment(event).format('YYYY-MM');
        const birthdayTimes = this.baseForm.birthdayDate.split('-');
        const birthYear = parseInt(birthdayTimes[0], 0);
        const nowYear = new Date().getFullYear();
        this.baseForm.age = nowYear - birthYear;
        this.updateInput();
    }

    // 处理表单值
    setFormValue() {
        this.baseForm.sexType = (this.baseForm.sex === '男' ? 1 : (this.baseForm.sex === '女' ? 2 : null));
    }

    // 上一步
    goBack() {
        const data = {
            currentStep: 2,
            move: 'back',
        };
        this.$emit('getRecruitInfo', data);
    }

    // 下一步
    goNext(formName: any) {
        this.setFormValue();
        let component = this as any;
        component.$refs[formName].validate((valid: any) => {
            if (valid) {
                const data = {
                    currentStep: 2,
                    move: 'next',
                    fromInfo: this.baseForm,
                };
                this.$emit('getRecruitInfo', data);
            } else {
                return false;
            }
        });
    }
}
